<div class="flex gap-1 items-center">
  <div class="w-full">
    <div class="p-inputgroup">
      <input
        style="position: relative"
        pInputText
        type="text"
        placeholder="Search Location"
        id="myInput"
        [(ngModel)]="searchInput"
        (ngModelChange)="inputOnChange()"
        [ngModelOptions]="{ standalone: true }"
        class="w-full" />
      <!--            <button [disabled]="!searchInput" type="button" pButton icon="pi pi-search"-->
      <!--                    (click)="getPlacePredictions()"></button>-->
    </div>
    <div
      *ngIf="searchInput"
      style="z-index: 1300"
      class="absolute overflow-hidden"
      id="myOptions">
      <div
        *ngIf="placeOptions.length > 0"
        class="p-card rounded-sm custom-width border-1 border-[#e5e7eb]">
        <div
          *ngFor="let op of placeOptions"
          class="px-2 py-3 hover:bg-slate-100 hover:cursor-pointer ellipsis"
          (click)="getPlaceById(op)">
          {{ op?.description }}
        </div>
      </div>
    </div>
  </div>
  <i
    *ngIf="searchLocationLoading"
    class="pi pi-spin pi-spinner mx-2"
    style="font-size: 1.5rem"></i>
</div>
